// [ai] goals: a checklist written into the view; what's ticked lives in the widget's own state (host.state → this browser).
import { useState } from "react";
import { useAtlas } from "../../sdk/react";
import type { WidgetProps } from "./hooks";
import type { Schema } from "../props";
export const GOALS_PROPS: Schema = { items: { type: "list", required: true } };
export function Goals({ spec }: WidgetProps) {
  const items = (spec.props!.items as unknown[]).filter((x): x is string => typeof x === "string"); const host = useAtlas();
  const [done, setDone] = useState<string[]>(() => { const d = host.state.get<unknown>("done"); return Array.isArray(d) ? d.filter((x): x is string => typeof x === "string") : []; });
  const toggle = (g: string) => { const next = done.includes(g) ? done.filter(x => x !== g) : [...done, g]; setDone(next); host.state.set("done", next); };
  const n = items.filter(g => done.includes(g)).length;
  return (
    <div className="at-cat at-cat-goals"><div className="at-cat-head"><span className="at-goals-n">{n} / {items.length}</span></div>
      {items.length ? <ul className="at-goals">{items.map(g => <li key={g}><label className={done.includes(g) ? "done" : ""}><input type="checkbox" checked={done.includes(g)} onChange={() => toggle(g)} /><span>{g}</span></label></li>)}</ul> : <p className="at-cat-empty">No goals written yet.</p>}
    </div>
  );
}
